<template>
  <div>
    <modal
      :show.sync="showModal"
      bodyClasses="padding-body px-2 px-md-5"
      headerClasses="bg-success"
      cardClasses="modal-card-width"
      modalClasses="modal-width mt-0"
      @close="close"
    >
      <template slot="header">
        <h3 class="font-weight-bold text-light mb-0">
          <i class="nc-icon nc-money-coins" aria-hidden="true"></i>
          Selecciona una pasarela de pago -
          {{ membershipStatus === "VIGENTE" ? "[RENOVACIÓN]" : "[PAGO]" }}
        </h3>
      </template>
      <div class="col-12">
        <div class="col-md-3 d-flex flex-column">
          <p class="mb-0">FLOW.CL</p>
          <div
            class="col my-auto cursor-pointer btn rounded-pill shadow"
            :class="platform === 'FLOW' ? 'bg-scondary' : 'bg-light'"
          >
            <img
              src="https://www.flow.cl/images/header/logo-flow.svg"
              alt=""
              srcset=""
              class=""
              @click="selectPlatform('FLOW')"
            />
          </div>
        </div>
      </div>
      <div class="col-12 d-flex mt-3">
        <button
          type="button"
          class="btn btn-success btn-lg m-auto"
          :disabled="disableContinue"
          @click="handleContinue"
        >
          continuar
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import { html } from "d3";
import {
  Badge,
  Modal,
  CollapseItem,
  Collapse,
} from "src/components/UIComponents";
export default {
  components: {
    Modal,
    Badge,
    CollapseItem,
    Collapse,
  },
  data() {
    return {
      showModal: false,
      platform: "",
      membershipId: "",
      NID: "",
      category: "",
      branches: {},
      membershipStatus: "",
    };
  },
  computed: {
    disableContinue() {
      if (this.platform && this.membershipId && this.NID && this.category) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    test() {
      console.log(this.branches);
      const inputOptions = this.branches;
      this.$swal.fire({
        title: "Selecciona una sucursal de origen",
        input: "radio",
        inputOptions,
        iconHtml: '<i class="nc-icon nc-tap-01" aria-hidden="true"></i>',
        icon: "info",
        // grow: "row",
        customClass: {
          popup: " d-fle flex-column w-auto",
          input: "d-flex flex-column",
        },
        inputValidator: (value) => {
          if (!value) {
            return "You need to choose something!";
          }
        },
        preConfirm: (val) => {
          console.log("validado");
          console.log(val);
        },
      });
    },
    async handleContinue() {
      let response;
      const inputOptions = this.branches;
      const { value: selectedBranchString } = await this.$swal.fire({
        title: "Selecciona una sucursal de origen",
        input: "radio",
        inputOptions,
        iconHtml: '<i class="nc-icon nc-tap-01" aria-hidden="true"></i>',
        icon: "info",
        confirmButtonColor: `#6bd098`,
        cancelButtonColor: "#ef8157",
        showCancelButton: true,
        customClass: {
          popup: " d-fle flex-column w-auto",
          input: "d-flex flex-column",
        },
        inputValidator: (value) => {
          if (!value) {
            return "Debes elegir una sucursal!";
          }
        },
      });
      if (selectedBranchString) {
        this.$swal.fire({
          title: "Procesando...",
          text: "Estamos generando el link de pago, por favor espera un momento",
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            this.$swal.showLoading();
          },
        });
        try {
          const selectedBranch = JSON.parse(selectedBranchString);
          const query = {
            id: this.membershipId,
            rutSocio: this.NID,
            membresiaTipo: this.category,
            sucursal: `${selectedBranch._id}`,
            nombreSucursal: selectedBranch.nombreSucursal,
            plataforma: this.platform,
          };
          // console.log(query);
          response = await this.$MasterControlAPI.post(
            "",
            {
              Header: {
                Operacion: "/v1/create/pagoenlinea/membresia",
              },
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: query,
              Body: {},
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
              },
            }
          );
        } catch (error) {
          // console.log(error);
          let errString;
          if (
            error.response &&
            error.response.data &&
            error.response.data.Response &&
            error.response.data.Response.Resultado
          ) {
            errString = error.response.data.Response.Resultado.MensajeServicio;
          } else {
            errString =
              error.message ||
              "Ha ocurrido un error inesperado, vuelve a intentarlo mas tarde o ponte en contacto con soporte";
          }

          this.$swal.fire({
            icon: "error",
            title: "Error!",
            text: errString,
            confirmButtonColor: "#6bd098",
          });

          return;
        }

        if (
          response &&
          response.data &&
          response.data.Response &&
          response.data.Response.DataOut
        ) {
          // console.log("OK");
          const link = response.data.Response.DataOut.url;
          const commerceOrder = response.data.Response.DataOut.commerceOrder;

          this.$swal.fire({
            title: `Link de Pago Generado`,
            icon: "success",
            html: `<p>El enlace de pago ha sido generado y enviado al socio pagador por correo electrónico:</p>
                  <div class="text-truncate mb-2">
                    <small class="overflow-hidden"><a href="${link}" target="_blank" >${link}</a></small>
                  </div>
                  <button id="copy-link" class="swal2-confirm swal2-styled btn-success">
                    Copiar
                    <i class="fa fa-clone" aria-hidden="true"></i>
                  </button>`,
            showConfirmButton: false,
            willOpen: () => {
              // Añadir el evento de click para copiar el link
              const copyButton = document.getElementById("copy-link");
              copyButton.addEventListener("click", async () => {
                await navigator.clipboard
                  .writeText(link)
                  .then(() => {
                    this.$swal
                      .fire({
                        title: "Copiado",
                        text: "El enlace de pago ha sido copiado al portapapeles.",
                        icon: "success",
                        confirmButtonColor: "#6bd098", // Color personalizado del botón "OK"
                        confirmButtonText: "OK",
                      })
                      .then(() => {
                        console.log(`Copia Ok`);
                        this.close();
                      });
                  })
                  .catch(() => {
                    this.$swal
                      .fire({
                        title: "Error",
                        text: "No se pudo copiar el enlace. Intenta manualmente.",
                        html: `<small ><a href="${link}" target="_blank" >${link}</a></small>`,
                        icon: "error",
                        confirmButtonColor: "#6bd098", // Color personalizado del botón "OK"
                        confirmButtonText: "OK",
                      })
                      .then(() => {
                        console.log(`Copia Error`);
                        this.close();
                      });
                  });
              });
            },
          });
        } else {
          this.$swal.fire({
            icon: "warning",
            title: "UPS!",
            text: "No se logró confirmar la creación del link de pago, vuelve a intentarlo mas tarde o ponte en contacto con soporte si el problema persiste",
            confirmButtonColor: "#6bd098",
          })
          .then(()=> {
            this.close()
          });
        }
        // console.log("no return");
        this.showModal = false;
        this.close()
        return;
      }
    },
    selectPlatform(platform) {
      // console.log(platform);
      if (platform === this.platform) {
        this.platform = "";
      } else {
        this.platform = platform;
      }
      // console.log(this.platform);
    },
    start(membership, NID, category, status) {
      if (membership && NID && category) {
        this.membershipId = membership;
        this.NID = NID;
        this.category = category;
        this.showModal = true;
        this.membershipStatus = status;
      } else {
        this.$swal({
          icon: "error",
          title: "Ha ocurrido un error al ininciar el componente",
        }).then((res) => {
          this.showModal = false;
        });
      }
    },
    close() {
      this.membershipId = "";
      this.NID = "";
      this.category = "";
      this.platform = "";
      this.showModal = false;
    },
  },
  beforeMount() {
    let preBranches = JSON.parse(sessionStorage.getItem("xxxwypt5ip"));
    // console.log(preBranches);
    preBranches.forEach((i) => {
      this.branches[JSON.stringify(i)] = i.nombreSucursal;
    });
  },
};
</script>

<style>
.modal-width {
  margin-left: 12vw;
}
.modal-card-width {
  width: 80vw;
}
@media (max-width: 1250px) {
  .modal-card-width {
    width: 95vw;
  }
  .modal-width {
    margin-left: 3vw;
  }
  .padding-body {
    padding: auto, 0px;
  }
  .custom-index {
    z-index: 1500;
  }
}
</style>
